import React from 'react';

interface IconProps {
	color?: string;
	error?: boolean;
}

export const ChatBotBubbleIcon: React.FC<IconProps> = () => (
	<svg
		width="33"
		height="32"
		viewBox="0 0 33 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<circle cx="16.5" cy="16" r="16" fill="#F2F8FF" />
		<path
			d="M16.5006 8.95996C15.7944 8.95996 15.2206 9.53371 15.2206 10.24C15.2206 10.835 15.6306 11.3312 16.1806 11.475V12.48H13.3106C11.8931 12.48 10.7406 13.6325 10.7406 15.05V16.32H9.14062V20.16H10.7406V23.04H22.2606V20.16H23.8606V16.32H22.2606V15.05C22.2606 13.6325 21.1081 12.48 19.6906 12.48H16.8206V11.475C17.3719 11.3312 17.7806 10.835 17.7806 10.24C17.7806 9.53371 17.2069 8.95996 16.5006 8.95996ZM16.5006 9.59996C16.8531 9.59996 17.1406 9.88746 17.1406 10.24C17.1406 10.5925 16.8531 10.88 16.5006 10.88C16.1481 10.88 15.8606 10.5925 15.8606 10.24C15.8606 9.88746 16.1481 9.59996 16.5006 9.59996ZM13.3106 13.12H19.6906C20.7544 13.12 21.6206 13.9862 21.6206 15.05V22.4H19.7006V19.84H13.3006V22.4H11.3806V15.05C11.3806 13.9862 12.2469 13.12 13.3106 13.12ZM14.4206 15.04C13.6269 15.04 12.9806 15.6862 12.9806 16.48C12.9806 17.2737 13.6269 17.92 14.4206 17.92C15.2144 17.92 15.8606 17.2737 15.8606 16.48C15.8606 15.6862 15.2144 15.04 14.4206 15.04ZM18.5806 15.04C17.7869 15.04 17.1406 15.6862 17.1406 16.48C17.1406 17.2737 17.7869 17.92 18.5806 17.92C19.3744 17.92 20.0206 17.2737 20.0206 16.48C20.0206 15.6862 19.3744 15.04 18.5806 15.04ZM14.4206 15.68C14.8619 15.68 15.2206 16.0387 15.2206 16.48C15.2206 16.9212 14.8619 17.28 14.4206 17.28C13.9794 17.28 13.6206 16.9212 13.6206 16.48C13.6206 16.0387 13.9794 15.68 14.4206 15.68ZM18.5806 15.68C19.0219 15.68 19.3806 16.0387 19.3806 16.48C19.3806 16.9212 19.0219 17.28 18.5806 17.28C18.1394 17.28 17.7806 16.9212 17.7806 16.48C17.7806 16.0387 18.1394 15.68 18.5806 15.68ZM9.78062 16.96H10.7406V19.52H9.78062V16.96ZM22.2606 16.96H23.2206V19.52H22.2606V16.96ZM13.9406 20.48H15.2206V22.4H13.9406V20.48ZM15.8606 20.48H17.1406V22.4H15.8606V20.48ZM17.7806 20.48H19.0606V22.4H17.7806V20.48Z"
			fill="#28696D"
		/>
	</svg>
);

export const RecentChatIcon: React.FC<IconProps> = () => {
	return (
		<svg
			width="18"
			height="20"
			viewBox="0 0 18 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.62569 1.36804C8.62569 0.888628 8.24612 0.5 7.7779 0.5C7.3096 0.5 6.93003 0.888628 6.93003 1.36804V3.24312H2.95539C1.59932 3.24312 0.5 4.36861 0.5 5.75698V13.4375C0.5 14.8259 1.59931 15.9514 2.95539 15.9514H6.54799C7.01622 15.9514 7.39578 15.5628 7.39578 15.0833C7.39578 14.604 7.01622 14.2153 6.54799 14.2153H2.95539C2.53582 14.2153 2.19568 13.8671 2.19568 13.4375V5.75698C2.19568 5.32742 2.53582 4.97918 2.95539 4.97918H12.6007C13.0202 4.97918 13.3604 5.32742 13.3604 5.75698V8.00085C13.3604 8.48023 13.74 8.86884 14.2082 8.86884C14.6764 8.86884 15.0561 8.48023 15.0561 8.00085V5.75698C15.0561 4.36861 13.9568 3.24312 12.6007 3.24312H8.62569V1.36804ZM5.20122 7.22557C5.66947 7.22557 6.04906 7.61418 6.04906 8.09356V9.19606C6.04906 9.67551 5.66947 10.0641 5.20122 10.0641C4.73297 10.0641 4.35338 9.67551 4.35338 9.19606V8.09356C4.35338 7.61418 4.73297 7.22557 5.20122 7.22557ZM11.2024 8.09356C11.2024 7.61418 10.8228 7.22557 10.3545 7.22557C9.88626 7.22557 9.50669 7.61418 9.50669 8.09356V9.19606C9.50669 9.67551 9.88626 10.0641 10.3545 10.0641C10.8228 10.0641 11.2024 9.67551 11.2024 9.19606V8.09356ZM9.77435 11.0423C9.96983 11.4779 9.78343 11.9933 9.35793 12.1934L9.35619 12.1943L9.3543 12.1951L9.35001 12.1971L9.33933 12.2019C9.33235 12.2051 9.324 12.2088 9.31426 12.2129L9.3099 12.2148C9.28672 12.2247 9.25648 12.2371 9.21964 12.2511C9.14609 12.2791 9.04544 12.3138 8.92197 12.3476C8.67656 12.415 8.3318 12.4818 7.9252 12.4818C7.50421 12.4818 7.15597 12.4162 6.90641 12.3475C6.78134 12.313 6.68004 12.2775 6.60547 12.2484C6.56819 12.2339 6.53745 12.2209 6.51354 12.2103C6.4969 12.2029 6.48026 12.1953 6.46384 12.1873L6.46289 12.1868C6.041 11.9789 5.86363 11.4601 6.06673 11.0282C6.26813 10.5998 6.76804 10.4177 7.18772 10.6174C7.19063 10.6186 7.1979 10.6218 7.20938 10.6262C7.23532 10.6363 7.28205 10.6532 7.34688 10.671C7.47703 10.7069 7.67608 10.7458 7.9252 10.7458C8.15259 10.7458 8.34728 10.7081 8.48267 10.6709C8.48674 10.6698 8.64684 10.633 8.6573 10.6125L9.77435 11.0423ZM8.6573 10.6125L9.77435 11.0423C9.58009 10.6093 9.08113 10.4184 8.6573 10.6125ZM15.6016 12.1856C15.3314 11.9089 14.8932 11.9089 14.623 12.1856L14.4928 12.319C14.5372 12.8489 14.9538 13.2753 15.4716 13.3207L15.6016 13.1875C15.8718 12.9108 15.8718 12.4623 15.6016 12.1856ZM11.6934 15.185L13.1777 13.6654C13.4163 14.0773 13.754 14.4229 14.1563 14.6673L12.672 16.1869C12.2576 16.6112 12.1145 16.754 11.9596 16.868C11.8106 16.9776 11.6505 17.0705 11.4821 17.1448C11.3068 17.2222 11.1136 17.2743 10.545 17.4199L10.4705 17.4389L10.4891 17.3626C10.6312 16.7805 10.6822 16.5827 10.7577 16.4033C10.8304 16.2308 10.921 16.0669 11.0282 15.9144C11.1395 15.7558 11.279 15.6093 11.6934 15.185ZM13.4239 10.9581C14.3564 10.0034 15.8682 10.0034 16.8007 10.9581C17.7331 11.9127 17.7331 13.4605 16.8007 14.4151L13.871 17.4145L13.8255 17.4612C13.4736 17.8216 13.2298 18.0712 12.9493 18.2777C12.7011 18.4604 12.4342 18.6151 12.1535 18.739C11.8362 18.8791 11.5017 18.9646 11.0189 19.0881L10.9563 19.1041L9.51084 19.4741C9.22196 19.548 8.91631 19.4613 8.7057 19.2457C8.4951 19.0301 8.41051 18.7172 8.48267 18.4214L8.84407 16.9415L8.85969 16.8776C8.98033 16.3831 9.06383 16.0407 9.20067 15.7159C9.32174 15.4284 9.47283 15.1553 9.65124 14.901C9.8529 14.6138 10.0968 14.3643 10.4487 14.004L10.4944 13.9574L13.4239 10.9581Z"
				fill="#98A2B3"
			/>
		</svg>
	);
};

export const ChatBotIcon: React.FC<IconProps> = () => {
	return (
		<svg
			width="44"
			height="44"
			viewBox="0 0 44 44"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<circle cx="22" cy="22" r="22" fill="#F2F8FF" />
			<path
				d="M22.0009 11.4399C20.9416 11.4399 20.0809 12.3006 20.0809 13.3599C20.0809 14.2524 20.6959 14.9968 21.5209 15.2124V16.7199H17.2159C15.0897 16.7199 13.3609 18.4487 13.3609 20.5749V22.4799H10.9609V28.2399H13.3609V32.5599H30.6409V28.2399H33.0409V22.4799H30.6409V20.5749C30.6409 18.4487 28.9122 16.7199 26.7859 16.7199H22.4809V15.2124C23.3078 14.9968 23.9209 14.2524 23.9209 13.3599C23.9209 12.3006 23.0603 11.4399 22.0009 11.4399ZM22.0009 12.3999C22.5297 12.3999 22.9609 12.8312 22.9609 13.3599C22.9609 13.8887 22.5297 14.3199 22.0009 14.3199C21.4722 14.3199 21.0409 13.8887 21.0409 13.3599C21.0409 12.8312 21.4722 12.3999 22.0009 12.3999ZM17.2159 17.6799H26.7859C28.3816 17.6799 29.6809 18.9793 29.6809 20.5749V31.5999H26.8009V27.7599H17.2009V31.5999H14.3209V20.5749C14.3209 18.9793 15.6203 17.6799 17.2159 17.6799ZM18.8809 20.5599C17.6903 20.5599 16.7209 21.5293 16.7209 22.7199C16.7209 23.9106 17.6903 24.8799 18.8809 24.8799C20.0716 24.8799 21.0409 23.9106 21.0409 22.7199C21.0409 21.5293 20.0716 20.5599 18.8809 20.5599ZM25.1209 20.5599C23.9303 20.5599 22.9609 21.5293 22.9609 22.7199C22.9609 23.9106 23.9303 24.8799 25.1209 24.8799C26.3116 24.8799 27.2809 23.9106 27.2809 22.7199C27.2809 21.5293 26.3116 20.5599 25.1209 20.5599ZM18.8809 21.5199C19.5428 21.5199 20.0809 22.0581 20.0809 22.7199C20.0809 23.3818 19.5428 23.9199 18.8809 23.9199C18.2191 23.9199 17.6809 23.3818 17.6809 22.7199C17.6809 22.0581 18.2191 21.5199 18.8809 21.5199ZM25.1209 21.5199C25.7828 21.5199 26.3209 22.0581 26.3209 22.7199C26.3209 23.3818 25.7828 23.9199 25.1209 23.9199C24.4591 23.9199 23.9209 23.3818 23.9209 22.7199C23.9209 22.0581 24.4591 21.5199 25.1209 21.5199ZM11.9209 23.4399H13.3609V27.2799H11.9209V23.4399ZM30.6409 23.4399H32.0809V27.2799H30.6409V23.4399ZM18.1609 28.7199H20.0809V31.5999H18.1609V28.7199ZM21.0409 28.7199H22.9609V31.5999H21.0409V28.7199ZM23.9209 28.7199H25.8409V31.5999H23.9209V28.7199Z"
				fill="#28696D"
			/>
		</svg>
	);
};

export const SearchIcon: React.FC<IconProps> = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.08871 0C11.0017 0 14.1774 3.17574 14.1774 7.08871C14.1774 11.0017 11.0017 14.1774 7.08871 14.1774C3.17574 14.1774 0 11.0017 0 7.08871C0 3.17574 3.17574 0 7.08871 0ZM7.08871 12.6021C10.1345 12.6021 12.6021 10.1345 12.6021 7.08871C12.6021 4.04214 10.1345 1.57527 7.08871 1.57527C4.04214 1.57527 1.57527 4.04214 1.57527 7.08871C1.57527 10.1345 4.04214 12.6021 7.08871 12.6021ZM13.7718 12.6581L16 14.8855L14.8855 16L12.6581 13.7718L13.7718 12.6581Z"
				fill="#757575"
			/>
		</svg>
	);
};

export const EyeIcon: React.FC<IconProps> = (props: IconProps) => {
	return (
		<svg
			width="20"
			height="17"
			viewBox="0 0 20 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M19.9165 8.1C17.8972 3.41 14.0986 0.5 10 0.5C5.90143 0.5 2.10275 3.41 0.0834557 8.1C0.0284116 8.22617 0 8.36234 0 8.5C0 8.63766 0.0284116 8.77383 0.0834557 8.9C2.10275 13.59 5.90143 16.5 10 16.5C14.0986 16.5 17.8972 13.59 19.9165 8.9C19.9716 8.77383 20 8.63766 20 8.5C20 8.36234 19.9716 8.22617 19.9165 8.1ZM10 14.5C6.8311 14.5 3.83215 12.21 2.10275 8.5C3.83215 4.79 6.8311 2.5 10 2.5C13.1689 2.5 16.1679 4.79 17.8972 8.5C16.1679 12.21 13.1689 14.5 10 14.5ZM10 4.5C9.20915 4.5 8.43606 4.7346 7.77849 5.17412C7.12093 5.61365 6.60841 6.23836 6.30577 6.96927C6.00312 7.70017 5.92394 8.50444 6.07823 9.28036C6.23251 10.0563 6.61334 10.769 7.17256 11.3284C7.73177 11.8878 8.44426 12.2688 9.21991 12.4231C9.99556 12.5775 10.7996 12.4983 11.5302 12.1955C12.2609 11.8928 12.8853 11.3801 13.3247 10.7223C13.7641 10.0645 13.9986 9.29113 13.9986 8.5C13.9986 7.43913 13.5773 6.42172 12.8274 5.67157C12.0776 4.92143 11.0605 4.5 10 4.5ZM10 10.5C9.60458 10.5 9.21803 10.3827 8.88925 10.1629C8.56046 9.94318 8.30421 9.63082 8.15288 9.26537C8.00156 8.89991 7.96197 8.49778 8.03911 8.10982C8.11626 7.72186 8.30667 7.36549 8.58628 7.08579C8.86589 6.80608 9.22213 6.6156 9.60996 6.53843C9.99778 6.46126 10.3998 6.50087 10.7651 6.65224C11.1304 6.80362 11.4427 7.05996 11.6624 7.38886C11.882 7.71776 11.9993 8.10444 11.9993 8.5C11.9993 9.03043 11.7887 9.53914 11.4137 9.91421C11.0388 10.2893 10.5302 10.5 10 10.5Z"
				fill={props.error ? 'red' : '#777E91'}
			/>
		</svg>
	);
};

export const HideEyeIcon: React.FC<IconProps> = (props: IconProps) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.60623 6.08071C1.72698 6.02901 1.85673 6.00161 1.98807 6.00007C2.11941 5.99853 2.24976 6.02287 2.37169 6.07172C2.49362 6.12056 2.60473 6.19295 2.69868 6.28475C2.79263 6.37654 2.86757 6.48595 2.91923 6.60671L2.00023 7.00071L2.92023 6.60671L2.92323 6.61471L2.94423 6.65971C2.96423 6.70171 2.99523 6.76771 3.03823 6.85371C3.12423 7.02571 3.25723 7.27771 3.43823 7.58271C3.91531 8.38461 4.47503 9.13436 5.10823 9.81971C5.29794 10.0239 5.49473 10.2213 5.69823 10.4117C7.18023 11.8007 9.25123 13.0007 12.0002 13.0007C13.102 13.0056 14.1947 12.8013 15.2202 12.3987C16.4472 11.9157 17.4742 11.1887 18.3162 10.4007C19.4415 9.33143 20.367 8.07001 21.0492 6.67571L21.0762 6.61771L21.0812 6.60671C21.1882 6.36672 21.3853 6.17847 21.63 6.08266C21.8746 5.98685 22.1472 5.99118 22.3887 6.09471C22.6301 6.19825 22.8212 6.39267 22.9205 6.63593C23.0198 6.8792 23.0193 7.15177 22.9192 7.39471L22.9172 7.39971L22.9132 7.40771L22.9022 7.43371L22.8622 7.52071C22.64 7.98324 22.3927 8.43325 22.1212 8.86871C21.6215 9.67176 21.0488 10.427 20.4102 11.1247L21.2072 11.9217C21.3949 12.1092 21.5003 12.3636 21.5004 12.6289C21.5005 12.8941 21.3952 13.1486 21.2077 13.3362C21.0202 13.5239 20.7659 13.6293 20.5006 13.6294C20.2353 13.6295 19.9809 13.5242 19.7932 13.3367L18.9532 12.4967C18.3628 12.9755 17.7275 13.3961 17.0562 13.7527L17.8382 14.9547C17.912 15.0647 17.9632 15.1883 17.9888 15.3183C18.0144 15.4483 18.0139 15.582 17.9874 15.7118C17.9609 15.8416 17.9089 15.9648 17.8343 16.0743C17.7598 16.1838 17.6642 16.2774 17.5532 16.3497C17.4422 16.422 17.3179 16.4715 17.1876 16.4953C17.0573 16.5191 16.9236 16.5169 16.7942 16.4886C16.6647 16.4603 16.5422 16.4066 16.4338 16.3306C16.3253 16.2545 16.233 16.1577 16.1622 16.0457L15.1762 14.5317C14.4972 14.7397 13.7722 14.8867 13.0002 14.9557V16.5007C13.0002 16.7659 12.8949 17.0203 12.7073 17.2078C12.5198 17.3954 12.2654 17.5007 12.0002 17.5007C11.735 17.5007 11.4807 17.3954 11.2931 17.2078C11.1056 17.0203 11.0002 16.7659 11.0002 16.5007V14.9567C10.2252 14.8867 9.50023 14.7397 8.82323 14.5317L7.83823 16.0457C7.69033 16.2602 7.46457 16.4085 7.20898 16.459C6.9534 16.5096 6.68818 16.4584 6.46977 16.3164C6.25136 16.1743 6.09701 15.9526 6.03958 15.6985C5.98214 15.4444 6.02614 15.1779 6.16223 14.9557L6.94423 13.7527C6.24423 13.3827 5.61223 12.9527 5.04723 12.4957L4.20723 13.3357C4.01863 13.5179 3.76602 13.6187 3.50383 13.6164C3.24163 13.6141 2.99082 13.5089 2.80541 13.3235C2.62 13.1381 2.51483 12.8873 2.51256 12.6251C2.51028 12.3629 2.61107 12.1103 2.79323 11.9217L3.59023 11.1247C2.8828 10.3509 2.25622 9.50682 1.72023 8.60571C1.50612 8.2461 1.30891 7.8767 1.12923 7.49871C1.11805 7.47479 1.10705 7.45079 1.09623 7.42671L1.08623 7.40571L1.08423 7.39871L1.08323 7.39671C1.08023 7.39671 1.08023 7.39471 2.00023 7.00071L1.08123 7.39571C1.02935 7.27497 1.00177 7.14519 1.00008 7.01378C0.998392 6.88238 1.02262 6.75193 1.07138 6.6299C1.12014 6.50786 1.19247 6.39663 1.28424 6.30257C1.37602 6.20851 1.48543 6.13246 1.60623 6.08071Z"
				fill={props.error ? 'red' : '#777E91'}
			/>
		</svg>
	);
};

export const CloseIcon: React.FC<IconProps> = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M6 6L18 18"
				stroke="black"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18 6L6 18"
				stroke="black"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const BackArrowIcon: React.FC<IconProps> = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			height="24px"
			viewBox="0 -960 960 960"
			width="24px"
			fill="#000000">
			<path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z" />
		</svg>
	);
};

export const InputImage = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M21 16.4407V12V5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H13.5977"
				stroke="#28696D"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.5 10C9.32843 10 10 9.32843 10 8.5C10 7.67157 9.32843 7 8.5 7C7.67157 7 7 7.67157 7 8.5C7 9.32843 7.67157 10 8.5 10Z"
				stroke="#28696D"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21 15L16 10L5 21"
				stroke="#28696D"
				strokeWidth="1.4"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<g clipPath="url(#clip0_3622_24262)">
				<path
					d="M18.5977 17.8989V21.9823"
					stroke="#28696D"
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M16.5547 19.9407H20.638"
					stroke="#28696D"
					strokeWidth="1.4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_3622_24262">
					<rect
						width="7"
						height="7"
						fill="white"
						transform="translate(15.0977 16.4407)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export const SendChatIcon = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.86018 3.87735L14.9364 7.2499C18.1108 8.76282 18.1108 11.2371 14.9364 12.75L7.86018 16.1226C3.09858 18.3919 1.15591 16.5323 3.53671 12.0014L4.25591 10.6382C4.43778 10.2915 4.43778 9.71628 4.25591 9.36957L3.53671 7.99848C1.15591 3.4676 3.10684 1.60796 7.86018 3.87735Z"
				stroke="#28696D"
				strokeWidth="1.24"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4.49609 10H8.96009"
				stroke="#28696D"
				strokeWidth="1.24"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const RedFlag: React.FC<IconProps> = (props: IconProps) => {
	return (
		<svg
			width="16"
			height="19"
			viewBox="0 0 9 11"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M3.57745 7.3864L3.57295 7.3759C3.50535 7.35741 3.43832 7.33691 3.37195 7.3144L3.36695 7.3124C2.67623 7.07608 2.07669 6.62969 1.65226 6.03572C1.22783 5.44175 0.999753 4.72993 0.999953 3.9999C0.99973 3.10395 1.3431 2.24204 1.95935 1.59168C2.57559 0.941324 3.41778 0.552056 4.31244 0.504054C5.2071 0.456053 6.0861 0.752974 6.76839 1.33366C7.45068 1.91434 7.88431 2.73457 7.97995 3.6254C8.00195 3.8314 7.83195 3.9999 7.62495 3.9999C7.41795 3.9999 7.25245 3.8309 7.22495 3.6259C7.15845 3.14203 6.9643 2.6846 6.66246 2.30062C6.36062 1.91664 5.96198 1.61995 5.50751 1.44106C5.05304 1.26217 4.55913 1.20752 4.07654 1.28272C3.59395 1.35793 3.14009 1.56029 2.76161 1.86899C2.38312 2.1777 2.09366 2.58161 1.92298 3.03923C1.7523 3.49686 1.70656 3.99167 1.79044 4.47283C1.87433 4.95398 2.08483 5.40413 2.4003 5.77699C2.71577 6.14985 3.12483 6.43199 3.58545 6.5944C3.67824 6.38466 3.84031 6.21319 4.04448 6.10873C4.24866 6.00427 4.48254 5.97317 4.70692 6.02063C4.9313 6.0681 5.13254 6.19125 5.27692 6.36945C5.42131 6.54764 5.50005 6.77005 5.49995 6.9994C5.50019 7.23053 5.42034 7.45461 5.27401 7.63352C5.12768 7.81243 4.92388 7.93512 4.6973 7.98074C4.47071 8.02635 4.23531 7.99206 4.03115 7.88371C3.82699 7.77535 3.66667 7.59962 3.57745 7.3864ZM3.06495 8.0014C2.47542 7.78967 1.93998 7.45023 1.49695 7.0074C1.22302 7.03927 0.97034 7.17064 0.786906 7.37657C0.603472 7.58249 0.502067 7.84862 0.501953 8.1244V8.5844C0.501953 8.8704 0.590953 9.1494 0.756953 9.3824C1.52795 10.4644 2.78995 10.9999 4.49995 10.9999C6.20995 10.9999 7.47245 10.4639 8.24495 9.3824C8.41172 9.14916 8.5014 8.86962 8.50145 8.5829V8.1239C8.50145 7.8257 8.38306 7.53971 8.1723 7.32876C7.96154 7.11781 7.67565 6.99916 7.37745 6.9989H6.24995C6.25003 7.37132 6.13129 7.73406 5.91101 8.03436C5.69073 8.33465 5.38039 8.55684 5.02513 8.6686C4.66987 8.78037 4.28822 8.77588 3.93568 8.65579C3.58315 8.53571 3.27812 8.30679 3.06495 8.0014ZM6.49995 3.9999C6.49995 3.70761 6.43589 3.41888 6.31227 3.15402C6.18866 2.88916 6.00849 2.65462 5.78445 2.4669C5.57649 2.29293 5.33532 2.16307 5.07561 2.0852C4.8159 2.00733 4.54307 1.98308 4.2737 2.01392C4.00432 2.04476 3.74403 2.13006 3.50865 2.26462C3.27326 2.39917 3.06769 2.58019 2.90443 2.79666C2.74117 3.01313 2.62363 3.26053 2.55895 3.52384C2.49427 3.78714 2.4838 4.06085 2.52819 4.32833C2.57257 4.5958 2.67087 4.85146 2.81713 5.07977C2.96338 5.30807 3.15453 5.50426 3.37895 5.6564C3.69351 5.39384 4.09022 5.24999 4.49995 5.2499C4.92645 5.2499 5.31745 5.4024 5.62145 5.6564C5.8921 5.4731 6.1137 5.22626 6.26685 4.93748C6.42001 4.64869 6.50004 4.32678 6.49995 3.9999Z"
				fill={props.color}
			/>
		</svg>
	);
};

export const SendLinkIcon = () => {
	return (
		<svg
			width="16"
			height="18"
			viewBox="0 0 16 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.50768 2.08999C7.86186 -0.163462 11.6683 -0.163462 14.0225 2.08999C16.3915 4.35762 16.3915 8.04548 14.0225 10.3131L7.66404 16.3995C5.99199 18 3.29147 18 1.61942 16.3995C-0.0674274 14.7848 -0.0674286 12.1556 1.61942 10.5409L7.88638 4.54207C8.87631 3.5945 10.4709 3.5945 11.4608 4.54207C12.4655 5.50382 12.4655 7.07443 11.4608 8.03617L5.14811 14.0788C4.90873 14.3079 4.52892 14.2996 4.29979 14.0603C4.07065 13.8209 4.07895 13.4411 4.31833 13.2119L10.631 7.1693C11.1421 6.68007 11.1421 5.89818 10.631 5.40894C10.1051 4.90554 9.24206 4.90554 8.71616 5.40894L2.4492 11.4078C1.25598 12.55 1.25598 14.3905 2.4492 15.5326C3.65723 16.689 5.62624 16.689 6.83426 15.5326L13.1927 9.44623C15.0681 7.65112 15.0681 4.75198 13.1927 2.95686C11.3026 1.14758 8.22761 1.14758 6.33746 2.95686L1.21411 7.86102C0.974731 8.09016 0.594923 8.08186 0.365785 7.84248C0.136647 7.6031 0.144949 7.22329 0.384329 6.99415L5.50768 2.08999Z"
				fill="#28696D"
			/>
		</svg>
	);
};

export const PDFIcon = () => {
	return (
		<svg
			width="72"
			height="71"
			viewBox="0 0 72 71"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M59.9995 68.073H28.9883C23.4654 68.073 18.9883 63.5959 18.9883 58.073V12.5C18.9883 6.97716 23.4654 2.5 28.9883 2.5H48.1149L69.9995 24.3846V58.073C69.9995 63.5959 65.5224 68.073 59.9995 68.073Z"
				fill="#EEF1F7"
				stroke="#CBD0DC"
				strokeWidth="4"
			/>
			<rect
				y="31.2422"
				width="48.5393"
				height="28.3146"
				rx="7"
				fill="#D82042"
			/>
			<path
				d="M8.04688 52.2763V38.7441H12.8704C13.9232 38.7441 14.7953 38.9358 15.4869 39.319C16.1785 39.7022 16.6961 40.2264 17.0397 40.8916C17.3833 41.5523 17.5551 42.2968 17.5551 43.1249C17.5551 43.9575 17.3811 44.7063 17.0331 45.3715C16.6895 46.0322 16.1697 46.5564 15.4737 46.9441C14.7821 47.3273 13.9121 47.5189 12.8637 47.5189H9.54678V45.7877H12.6787C13.3439 45.7877 13.8835 45.6732 14.2976 45.4442C14.7116 45.2107 15.0156 44.8935 15.2094 44.4927C15.4032 44.0918 15.5001 43.6359 15.5001 43.1249C15.5001 42.6139 15.4032 42.1602 15.2094 41.7638C15.0156 41.3673 14.7094 41.0568 14.291 40.8321C13.8769 40.6075 13.3307 40.4951 12.6523 40.4951H10.0886V52.2763H8.04688Z"
				fill="white"
			/>
			<path
				d="M24.3294 52.2763H19.9486V38.7441H24.4682C25.7941 38.7441 26.9328 39.015 27.8843 39.5569C28.8357 40.0943 29.5648 40.8674 30.0714 41.8761C30.5823 42.8804 30.8378 44.0852 30.8378 45.4904C30.8378 46.9 30.5801 48.1114 30.0647 49.1245C29.5538 50.1377 28.8137 50.9174 27.8446 51.4636C26.8755 52.0054 25.7038 52.2763 24.3294 52.2763ZM21.9904 50.4923H24.2171C25.2479 50.4923 26.1046 50.2985 26.7874 49.9108C27.4702 49.5188 27.9812 48.9527 28.3204 48.2127C28.6595 47.4683 28.8291 46.5608 28.8291 45.4904C28.8291 44.4288 28.6595 43.528 28.3204 42.7879C27.9856 42.0479 27.4856 41.4863 26.8205 41.103C26.1553 40.7198 25.3294 40.5282 24.3426 40.5282H21.9904V50.4923Z"
				fill="white"
			/>
			<path
				d="M33.3768 52.2763V38.7441H41.7683V40.5017H35.4185V44.6248H41.167V46.3758H35.4185V52.2763H33.3768Z"
				fill="white"
			/>
		</svg>
	);
};

export const DownloadIcon: React.FC<IconProps> = (props: IconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			height="24px"
			viewBox="0 -960 960 960"
			width="24px"
			fill={props.color}>
			<path d="M300-300h360v-40H300v40Zm180-127.69L612.31-560 584-588.31l-84 83.54V-700h-40v195.23l-84-83.54L347.69-560 480-427.69Zm.13 307.69q-74.67 0-140.41-28.34-65.73-28.34-114.36-76.92-48.63-48.58-76.99-114.26Q120-405.19 120-479.87q0-74.67 28.34-140.41 28.34-65.73 76.92-114.36 48.58-48.63 114.26-76.99Q405.19-840 479.87-840q74.67 0 140.41 28.34 65.73 28.34 114.36 76.92 48.63 48.58 76.99 114.26Q840-554.81 840-480.13q0 74.67-28.34 140.41-28.34 65.73-76.92 114.36-48.58 48.63-114.26 76.99Q554.81-120 480.13-120Zm-.13-40q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
		</svg>
	);
};

export const ArrowDownIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			height="20px"
			viewBox="0 -960 960 960"
			width="20px"
			fill="#FFFFFF">
			<path d="M454-748v436.08L249.15-516.77 212-480l268 268 268-268-37.15-36.77L506-311.92V-748h-52Z" />
		</svg>
	);
};
